import { Link } from 'react-router-dom';
import { BackArrowIcon, NextPageIcon } from '../icons';
import * as styles from './styles.module.css';

/**
 * Breadcrumbs component
 *
 * Renders breadcrumb items with navigation support.
 * Uses React Router Link for navigation when path is provided.
 *
 * @param {Object} props
 * @param {Array<{label: string, path?: string}>} props.items - Breadcrumb items to render
 */
export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) {
    return <div className={styles['breadcrumbs-container']} />;
  }

  const isSingleItem = items.length === 1;

  return (
    <div className={styles['breadcrumbs-container']}>
      <div className={styles['breadcrumbs-content']}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          const isFirst = i === 0;
          const hasArrow = isFirst && !isSingleItem;
          const key = item.path ? `${item.path}-${i}` : `${item.label}-${i}`;
          const itemClassName = isSingleItem ? styles['breadcrumb-item-first'] : '';

          return (
            <span key={key} className={styles['breadcrumb-wrapper']}>
              {hasArrow && item.path && (
                <Link to={item.path} className={styles['breadcrumb-back-arrow']}>
                  <BackArrowIcon />
                </Link>
              )}
              {hasArrow && !item.path && (
                <span className={styles['breadcrumb-back-arrow']}>
                  <BackArrowIcon />
                </span>
              )}
              {item.path && !isLast ? (
                <Link to={item.path} className={`${styles['breadcrumb-link']} ${itemClassName}`}>
                  {item.label}
                </Link>
              ) : (
                <span className={`${styles['breadcrumb-item']} ${itemClassName}`}>{item.label}</span>
              )}
              {!isLast && (
                <span className={styles['breadcrumb-separator-arrow']}>
                  <NextPageIcon />
                </span>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
}
